import { Button, Flex, FlexProps } from "@chakra-ui/react";
import { FC } from "react";

import { track } from "lib/analytics";
import { Link } from "ui";

interface CTALinksProps extends FlexProps {
  primary: "signup" | "demo";
  primaryText?: string;
  includeChangelog?: boolean;
  hideSecondary?: boolean;
}

export const ChangelogLink: FC = () => {
  const trackChangelogClicked = () => {
    track("Changelog Clicked", {
      page: window.location.href,
    });
  };

  return (
    <Link
      href="/changelog"
      fontSize="md"
      fontWeight="medium"
      color="text.secondary"
      transition="color 150ms ease"
      _hover={{ color: "text.primary", textDecoration: "none" }}
      onClick={trackChangelogClicked}
    >
      Changelog
    </Link>
  );
};

export const CTALinks: FC<Readonly<CTALinksProps>> = ({
  primary,
  primaryText,
  includeChangelog,
  hideSecondary,
  ...props
}) => {
  const demoClicked = () => {
    track("Demo Clicked", {
      page: window.location.href,
    });
  };

  const signUpClicked = () => {
    track("Sign Up Clicked", {
      page: window.location.href,
    });
  };

  if (primary === "signup") {
    return (
      <Flex align="center" gap={3} {...props}>
        {includeChangelog && <ChangelogLink />}

        <Button
          as="a"
          href="https://hightouch.com/demo"
          display={{ base: "flex", md: "none" }}
          onClick={demoClicked}
        >
          Book a demo
        </Button>

        <Button
          as="a"
          href="https://app.hightouch.com/signup"
          display={{ base: "none", md: "flex" }}
          onClick={signUpClicked}
        >
          {primaryText || "Sign up"}
        </Button>

        {!hideSecondary && (
          <Button
            as="a"
            variant="secondary"
            href="https://hightouch.com/demo"
            display={{ base: "none", md: "flex" }}
            onClick={demoClicked}
          >
            Book a demo
          </Button>
        )}
      </Flex>
    );
  }

  return (
    <Flex align="center" gap={3} {...props}>
      {includeChangelog && <ChangelogLink />}

      <Button as="a" href="https://hightouch.com/demo" onClick={demoClicked}>
        {primaryText || "Book a demo"}
      </Button>

      {!hideSecondary && (
        <Button
          as="a"
          href="https://app.hightouch.com/signup"
          variant="secondary"
          display={{ base: "none", md: "flex" }}
          onClick={signUpClicked}
        >
          Sign up
        </Button>
      )}
    </Flex>
  );
};
